import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { User } from '../../../models/identity/user.model';

@Injectable({ providedIn: 'root' })
export class UserInterestsService {
    constructor(private http: HttpClient) {}

    public addUserInterests(user: User): Observable<any> {
        return this.http.post(
            `${environment.microservices.identity.baseUrl}/${environment.microservices.identity.usersApi.baseUrl}/${user.userId}/interests`,
            { interests: user.interests.map((userInterest) => userInterest.id) },
        );
    }
}
